var map = {
	"./da.json": 9260,
	"./de.json": 4871,
	"./el.json": 3724,
	"./en.json": 3197,
	"./es.json": 3045,
	"./fr.json": 173,
	"./it.json": 7592,
	"./ja.json": 9486,
	"./nb.json": 4800,
	"./nl.json": 7827,
	"./pl.json": 8697,
	"./sv.json": 2484
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6828;